// TODO: Remove this finally! This does not exist on our "library".
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map';
import { TeComponent } from './common/te-component';
import { theme } from './common/theme';
import './te-text';

/** Popover Component */
@customElement('te-popover')
export class TePopover extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .popover-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        background: ${theme.colors.primary.v0};
        padding: 16px;
        white-space: nowrap;
        border-radius: 4px;
      }

      .popover-tip {
        width: 14px;
        height: 14px;
        position: absolute;
        top: -6px;
        background: ${theme.colors.primary.v0};
        transform: rotate(135deg);
        border-radius: 0 0 0 2px;
        clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
      }

      .popover-wrapper.hidden {
        visibility: hidden;
      }
    `,
  ];

  /** Element the popover is anchored to */
  @property({ type: Object }) anchorEl: Element | undefined;

  // The popover positioning solution expects the anchor element and the anchor to have set position. Another alternative would be positioning
  // the popover just using the rect and not have any relation to anchor, but if the position is relative to the page itself then scrolling will
  // break the solution requiring either disabling scrolling (like material-ui does) or updating the position when scroll changes.
  getStyles(anchorEl?: Element, popoverEl?: Element | null) {
    if (!anchorEl || !popoverEl) return {};

    const anchorRect = anchorEl.getBoundingClientRect();
    const popoverRect = popoverEl.getBoundingClientRect();

    return {
      bottom: `-${popoverRect.height}px`,
      right: `-${popoverRect.width / 2 - anchorRect.width / 2}px`,
    };
  }

  render() {
    const popoverEl = this.shadowRoot?.querySelector('.popover-wrapper');

    if (this.anchorEl && popoverEl) {
      setTimeout(() => {
        window.addEventListener('click', () => this.sendEvent('teClosed', new Event('closed')), {
          once: true,
        });
      }, 0);
    }

    return html`
      <div
        class="popover-wrapper ${this.anchorEl ? '' : 'hidden'}"
        style=${styleMap(this.getStyles(this.anchorEl, popoverEl))}
      >
        <div class="popover-tip"></div>
        <div class="popover">
          <te-text size="14" color="${theme.colors.shade0.toString()}">
            Code copied
          </te-text>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-popover': TePopover;
  }
}
